// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__31QV4","header":"PatientBlock_header__6mwCO","label":"PatientBlock_label__np9IO","option":"PatientBlock_option__1cu2B"};